import React from "react";
import { Spinner } from "reactstrap";

export const OnboardingLoader: React.FC = () => {
  return <Spinner animation="border" role="status" />;
};
